export default "__VITE_ASSET__d3e3567a__"